import { RoleModel } from '../../../security/models/RoleModel';
import { ActionBase } from '../../../core/store/action/ActionBase';

export const REMOVE_ROLE_FROM_USER = '[Customer] User Remove Role';

export class RemoveRoleFromUserAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = REMOVE_ROLE_FROM_USER;

  constructor(public payload: { userKey: string, role: RoleModel }) {}
}



// WEBPACK FOOTER //
// ./src/app/customer/store/actions/RemoveRoleFromUserAction.ts